import {createSelector} from "reselect"

const artisanProductsStateSelector = state => state.artisanProducts;
const selectById = (state, itemId) => itemId;

export const artisanProductsSelector = createSelector(
  [artisanProductsStateSelector],
  artisanProducts => artisanProducts.items,
);

export const artisanProductByIdSelector = createSelector(
  [artisanProductsSelector, selectById],
  (artisanProducts, _id) => {
    const product = artisanProducts.find(item => _id === item._id)
    if(!product) return null
    return product
  }
)

export const artisansProductsAsLabelAndValueSelector = createSelector(
  [artisanProductsSelector],
   (artisans) =>
    artisans.map(({ _id, name }) => ({
      value: _id,
       label:name,
    }))
)


export const artisanProductsIsLoadingSelector = createSelector(
  [artisanProductsStateSelector],
  artisanProducts => artisanProducts.isLoading
)

export const artisanProductsCountSelector = createSelector(
  [artisanProductsStateSelector],
  artisanProducts => artisanProducts.count
)

export const searchValueSelector = createSelector(
  [artisanProductsStateSelector],
  artisanProducts => artisanProducts.searchValue
)